<div class="desktop-width-limiter newevent-page page-padding">
  <div class="create-event-page">
    <div class="create-event-container">

      <!-- Stepper Container -->
      <div class="stepper-container">
        <mat-stepper (selectionChange)="onStepChange($event)" [selectedIndex]="eventFormStore.currentStep()"
          orientation="vertical">
          @for (step of eventFormStore.steps(); track step; let i = $index) {
          <mat-step [state]="step.state" [disabled]="step.disabled">
            <ng-template matStepLabel>
              <div class="step-content">
                <span class="step-text">{{
                  "event_steps." + step.title + ".label" | translate
                  }}</span>
                <span class="step-box" [ngClass]="{
                  'step-box-active': step.state === 'active',
                  'step-box-completed': step.state === 'completed',
                  'step-box-default': step.state === 'default',
                  'step-box-disabled': step.disabled
                }">{{ step.letter }}</span>
              </div>
            </ng-template>
          </mat-step>
          }
        </mat-stepper>
      </div>

      <div class="content-container-wrapper">
        <div class="content-container">
          @switch (eventFormStore.currentStep()) {
            @case(0) {
              <media-upload-step />
            }
            @case(1) {
            <!-- 
              The location selection step is rendered outside of the switch statement to preserve its state when
              navigating between steps. --- IGNORE ---
            -->
            }
            @case(2) {
              <details-step [formGroup]="streappFormGroup.controls.detailsForm" />
            }
            @case(3) {
              <category-selection-step />
            }
            @case(4) {
              <additonal-details-step [formGroup]="streappFormGroup.controls.additionalDetailsForm" />
            }
            @case (5) {
              <pricing-step />
            }
            @case (6) {
              <submit-step-create-event [formGroup]="streappFormGroup" />
            }
          }

          <location-selection-step
            [formGroup]="streappFormGroup"
            [style.display]="eventFormStore.currentStep() === 1 ? 'block' : 'none'" 
          />

          <div class="navigation-buttons">
            <!-- Previous Step -->
            <div class="button-wrapper">
              @if (eventFormStore.canGoBack()) {
              <button matRipple (click)="previousStep()" class="secondary-button">
                <mat-icon>keyboard_arrow_left</mat-icon>
                {{ "general.previous" | translate | titlecase }}
              </button>
              }
            </div>

            <!-- Next Step -->
            <div class="button-wrapper">
              @if ((eventFormStore.currentStep() !== 6))
              {
              <button matRipple [disabled]="!eventFormStore.canGoNext()" (click)="nextStep()" class="secondary-button">
                {{ "general.next" | translate | titlecase }}
                <mat-icon>keyboard_arrow_right</mat-icon>
              </button>
              }

              <!-- Create streapp button -->
              <div class="button-wrapper">
                @if (eventFormStore.currentStep() === 6 && eventFormStore.isValid() && !eventFormStore.isLoading()) {
                <button matRipple id="submit" class="save-button" (click)="createEvent()"
                  [disabled]="!eventFormStore.isValid() || eventFormStore.isLoading()">
                  {{ "event_steps.step_publish.button_publish" | translate | titlecase }}
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>